import { useContext } from "react";
import PageLoadingContext from "./context";

export const usePageLoading = () => {
  const context = useContext(PageLoadingContext);

  return context;
}